var React = require('react');

function Ball13 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M89.1,45c0,24.4-19.8,44.1-44.1,44.1C20.6,89.1,0.9,69.4,0.9,45C0.9,20.6,20.6,0.9,45,0.9C69.4,0.9,89.1,20.6,89.1,45\n\tL89.1,45z M89.1,45"}));
}

Ball13.defaultProps = {"viewBox":"0 0 90 90"};

module.exports = Ball13;

Ball13.default = Ball13;
